module.exports = __webpack_public_path__ + "img/header-diamondJewelryWhitegold@2x.ac462a2.webp";